// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18jOp","clinicsSelect":"styles_clinicsSelect__Uswj_"};